module.exports = __webpack_public_path__ + "img/bgc4.15eda71b.jpg";